exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (max-width: 767px) {\n.scrollable-table-seats[data-v-d4463766] {\n        overflow: scroll;\n}\n}\n#infoTabContent[data-v-d4463766] {\n    min-height: 0;\n}\n#infoTabContent .tab-pane[data-v-d4463766] {\n    min-height: 0;\n}\n#infoTabContent .table-cell[data-v-d4463766] {\n    height: 400px;\n}\n", ""]);

// exports
